<template>
  <div>
    <div
      class="process_list"
      v-if="$store.getters.allAuthUser"
      style="
        background-color: #fff5e6;
        border-color: #ffebcc;
        padding: 5px;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      "
    >
      <p style="display: flex; align-items: center">
        <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
        <span class="process_list_num">1</span>
        <span v-if="isInDingTalk">创建审批流程</span>
        <a v-else href="https://www.junziqian.com/help_detail-10.html" target="_blank">创建审批流程</a>
        <i class="el-icon-right icon_size"></i>
        <span class="process_list_num">2</span>
        <span>设置审批流程使用范围</span>
      </p>
    </div>
    <!-- SaaS web -->
    <div class="main-warp" v-if="!isInDingTalk">
      <contract-approval></contract-approval>
    </div>
    <!-- 钉钉微应用 -->
    <div v-if="isInDingTalk">
      <dingFlow></dingFlow>
    </div>
  </div>
</template>


<script>
// components
import dingFlow from "./dingComponents/dingFlow.vue";
import contractApproval from "./components/contractApproval/contractApproval.vue";
// API
import { isInDingTalk } from "../../assets/js/utils/ding-env";
// tool

// 状态 组件
let status = {
  render: function (createElement) {
    let data = this.data;
    return createElement("div", [
      createElement(
        "span",
        {
          style: {
            color:
              data.useStatus === 1
                ? "#adadad"
                : data.useStatus === 0
                  ? "#67C23A"
                  : "#Ec1c1c",
            marginRight: "5px"
          }
        },
        "●"
      ),
      createElement(
        "span",
        data.useStatus === 1
          ? "已停用"
          : data.useStatus === 0
            ? "启用中"
            : "已删除"
      )
    ]);
  },
  props: {
    data: {}
  }
};

//新增 审批流程列 21-03-23
let orderFlag = {
  render: function (createElement) {
    let data = this.data;
    return createElement("div", [
      createElement(
        "span",
        (data.orderFlag === 1 ? "顺序审批：" : "会审：") + data.allPartName
      )
    ]);
  },
  props: {
    data: {}
  }
};

export default {
  name: "flow",
  components: { dingFlow, contractApproval },
  data () {
    return {
      isInDingTalk,
    };
  },
  beforeMount () {},
  mounted () {},
  methods: {},
  computed: {}
};
</script>

<style lang="less" scoped>
  .main-warp {
    min-height: calc(100vh - 210px);
    background-color: #ffffff;
  }
.process_list {
  color: #606266;
  font-size: 14px;
  .process_list_num {
    display: inline-block;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    border: 2px solid #606266;
    border-radius: 50%;
    margin-right: 6px;
  }
  .icon_size {
    margin: 0 20px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/flow.vue